import {
  LoadingSpinner,
  LoadingSpinnerProps,
  styled,
} from '@zeiss/beyond-online-react';

const Container = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

export const PageLoaderContent = (props: LoadingSpinnerProps) => {
  return (
    <Container>
      <LoadingSpinner {...props} />
    </Container>
  );
};
